import { addressOwnersFetch } from '../../../api/addressOwners';
import { State, StateContext } from '../base/state';
import { stateTypes } from '../constants';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.owners,
    });
  }

  async getOwners(addressId) {
    this.transitionTo(new LoadingState());

    const result = await addressOwnersFetch({
      queryClient: this.controller.queryClient,
      params: { addressId },
    });

    if (result === 'Error') {
      this.transitionTo(
        new ErrorState({
          refetch: () => this.getOwners(addressId),
        })
      );
      return;
    }

    this.transitionTo(new SuccessState(result));
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor() {
    super({
      status: 'error',
      message: 'Не удалось получить список собственников. Попробуйте еще раз',
    });
  }
}

export class SuccessState extends State {
  constructor(value) {
    super({ status: 'success', value });
  }
}
